import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import backendApi from '../../services/backendApi';
import { rememberProject } from '../../utils/projectPreference';
import ClientPage from '../common/ClientPage';

// Resolves the active project without asking the client to select one.
export default function ProjectSelection() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [empty, setEmpty] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setError(null);
    setEmpty(false);
    backendApi.getProjects().then(({ projects = [] }) => {
      if (cancelled) return;
      const savedId = Number(localStorage.getItem('selected_project_id'));
      const selected = projects.find(project => project.id === savedId) || projects[0];
      if (!selected) { setEmpty(true); return; }
      rememberProject(selected, user);
      navigate('/dashboard', { replace: true });
    }).catch(err => { if (!cancelled) setError(err.message || 'Impossible de charger vos projets.'); });
    return () => { cancelled = true; };
  }, [navigate, user, attempt]);
  if (!error && !empty) return <div className="p-8 text-center" role="status">Ouverture de votre projet…</div>;
  return <ClientPage title={empty ? 'Aucun projet accessible' : 'Projet indisponible'}>
    <p>{empty ? 'Aucun projet n’est actuellement associé à votre compte.' : error}</p>
    <div className="flex gap-4 mt-4">
      <button type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button>
      <button type="button" onClick={async () => { await logout(); navigate('/login'); }}>Se déconnecter</button>
    </div>
  </ClientPage>;
}
